import ExternalLinkRedirect from "../utils/ExternalLinkRedirect";

export default function AlumnoDeuda() {
  return <ExternalLinkRedirect idMenu={391} />;
}
